import React from 'react'

const ArtVsArtist = () => {
  return <>art vs artist</>
}

export default ArtVsArtist
